export default __webpack_public_path__ + "static/media/marine.92ee5935.jpg";